import Configuracoes from './Configuracoes';

export default Configuracoes;